module.exports = __webpack_public_path__ + "img/back_buttons_quantity.68d5cba9.png";